'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Func = /** @class */ (function () {
    function Func() {
    }
    Func.getValuesToNumbersArray = function (val) {
        var vals = [];
        if (val.match(',')) {
            var a = val.split(',');
            var b = a.map(function (v) {
                return v.replace(/ /, '');
            });
            var c = b.filter(function (v) {
                return (v);
            });
            vals = c.map(function (v) {
                return Number(v);
            });
        }
        else {
            var c = [val].filter(function (v) {
                return (v);
            });
            vals = c.map(function (v) {
                return Number(v);
            });
        }
        return vals;
    };
    Func.sum = function (numbers) {
        var sum = 0;
        numbers.forEach(function (num) {
            sum += num;
        });
        return sum;
    };
    Func.getExtention = function (filename) {
        var types = filename.split('.');
        return types[types.length - 1].toLowerCase();
    };
    Func.numberFormat = function (number) {
        return number.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,');
    };
    Func.unitFormat = function (number, unit) {
        if (unit === void 0) { unit = "B"; }
        var str = number;
        if (number > 1 * 1000 * 1000 * 1000) {
            str = Func.numberFormat((number / 1000 / 1000 / 1000).toFixed(2)) + "G";
        }
        else if (number > 1 * 1000 * 1000) {
            str = Func.numberFormat((number / 1000 / 1000).toFixed(2)) + "M";
        }
        else if (number > 1 * 1000) {
            str = Func.numberFormat((number / 1000).toFixed(2)) + "K";
        }
        return str + unit;
    };
    Func.inArray = function (needle, haystack) {
        var result = false;
        Object.keys(haystack).forEach(function (i) {
            if (needle == haystack[Number(i)]) {
                result = true;
            }
        });
        return result;
    };
    Func.dateFormat = function (date, format) {
        if (format === void 0) { format = 'Y-m-d H:i:s'; }
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDay();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var second = date.getSeconds();
        return format.replace('Y', year)
            .replace('m', Func.sprintf(month, 2))
            .replace('d', Func.sprintf(day, 2))
            .replace('n', month)
            .replace('j', day)
            .replace('H', hour)
            .replace('i', minutes)
            .replace('s', second);
    };
    /**
     * @param number
     * @param number
     * @return string
     */
    Func.sprintf = function (num, len) {
        if (String(num).length >= len) {
            return String(num);
        }
        else {
            var zeros = len - String(num).length;
            var str = "";
            for (var i = 0; i < zeros; i++) {
                str += "0";
            }
            return str + String(num);
        }
    };
    Func.smoothScroll = function (target, flagAnimation, speed) {
        if (speed === void 0) { speed = 500; }
        if (flagAnimation === true) {
            var speed = speed | 500;
            $("html, body").animate({ scrollTop: target }, speed, "swing");
        }
        else {
            var speed = 0;
            $("html, body").animate({ scrollTop: target }, speed, "linear");
        }
        return false;
    };
    Func.getElementPosition = function (idName, minus) {
        if (minus === void 0) { minus = 0; }
        var pos = Number($(idName).offset().top);
        return pos - minus;
    };
    Func.number = function (val) {
        val = val.replace(/[^0-9]/g, '');
        if (isNaN(val)) {
            return 0;
        }
        else {
            return Number(val);
        }
    };
    Func.insertToTextarea = function (selector, word) {
        var textarea = document.querySelector(selector);
        var sentence = textarea.value;
        var len = sentence.length;
        var pos = textarea.selectionStart;
        var before = sentence.substr(0, pos);
        var after = sentence.substr(pos, len);
        sentence = before + word + after;
        textarea.value = sentence;
        var endPosition = pos + word.replace(/\r/g, '').length;
        textarea.setSelectionRange(endPosition, endPosition);
    };
    Func.getDeg = function (value) {
        var deg = 0;
        if (value.indexOf('厘')) {
            value = value.replace('分', '.').replace('厘', '');
        }
        else {
            value = value.replace('分', '');
        }
        if (value > 0) {
            deg = 45 * value / 10;
        }
        return deg;
    };
    Func.getCurlValue = function (value) {
        if (value.indexOf('.') == 1) {
            value = value.replace('.', '分') + '厘';
        }
        else {
            value = value + '分';
        }
        return value;
    };
    Func.getCreditCompany = function (value) {
        /*
         * VISA：最初の1桁が「4」
         * JCB：最初の2桁が「35」
         * MasterCard：最初の1桁が「5」
         * Diners Club：最初の2桁が「36」
         * American Express：最初の2桁が「34」もしくは「37」
         */
        var company = "";
        if (value.match(/^4/)) {
            company = 'visa';
        }
        else if (value.match(/^35/)) {
            company = 'jcb';
        }
        else if (value.match(/^5/)) {
            company = 'mastercard';
        }
        else if (value.match(/^36/)) {
            company = 'diners';
        }
        else if (value.match(/^34/) || value.match(/^37/)) {
            company = 'amex';
        }
        return company;
    };
    Func.setSelectValue = function (selectElementId, value) {
        var elm = $(selectElementId);
        elm.children('option').prop('selected', false);
        for (var i = 0; i < elm.children('option').length; i++) {
            var option = elm.children('option').eq(i);
            if (option.html() == value) {
                // console.log(option.html());
                option.prop('selected', true);
                return;
            }
        }
    };
    // Json データを取得
    Func.getJsonData = function (id) {
        if ($('#' + id).length > 0) {
            var elem = document.getElementById(id);
            if (elem) {
                return JSON.parse(elem.textContent);
            }
        }
    };
    // 税込
    Func.getTaxIn = function (taxoutNumber, tax) {
        var taxIn = taxoutNumber * (100 + tax) / 100;
        return Math.round(taxIn);
    };
    return Func;
}());
exports.default = Func;
